import allGamesBanner from './all-games-banner.webp';

export default {
  allGamesBanner,
};
